import axios from "axios";
import { reactive, ref } from "vue";
import { loading, errors, toast, meta, loadingBtn, remove } from "./shared";

export default function useUser(navigation) {
  const { route, router } = navigation;
  const users = ref([]);
  const user = reactive({
    numbers: [{ type: "mobile", value: "" }],
    billing: {},
    roles: [],
    sections: ['clue','person','invoice'],
    emails: [{ value: "" }],
    status: "active",
  });
  const getUsers = async (query = {}) => {
    try {
      errors.value = "";
      if (query.inline) loadingBtn.value = true;
      else loading.value = true;
      const search = isObjectNotEmpty(query)
        ? "?" + new URLSearchParams(query).toString()
        : "";
      let response = await axios.get("user/user" + search);
      if (query.inline) loadingBtn.value = false;
      else loading.value = false;
      users.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      if (query.inline) loadingBtn.value = false;
      else loading.value = false;
      loading.value = false;
    }
  };

  const getUser = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/user/" + route.params.id);
      loading.value = false;
      Object.assign(user, response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const addUser = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/user/create");
      loading.value = false;
      Object.assign(meta, { ...response.data });
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const editUser = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/user/" + route.params.id + "/edit");
      loading.value = false;
      Object.assign(user, response.data.data);
      Object.assign(meta, { ...response.data });
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeUser = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("user/user", user);
      progressDialog.value = false;
      toast.success(response.data.message);
      router.push({ name: "user.users" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const updateUser = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put("user/user/" + route.params.id, user);
      progressDialog.value = false;
      if (history.state.back) router.back();
      else router.push({ name: "user.users" });
      toast.success(response.data.message);
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const transferUser = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      const {transfer_id,sections} = user;
      let response = await axios.post("user/user/transfer", {user_id: user.id,transfer_id,sections});
      loadingBtn.value = false;
      document.getElementById('transfer-modal').checked = false;
      toast.success(response.data.message);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const removeUser = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/user/" + remove.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("delete-modal").checked = false;
      if (remove.single) {
        if (history.state.back) router.back();
        else router.push({ name: "user.users" });
      } else getUsers(route.query);
      remove.single = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  return {
    users,
    user,
    getUsers,
    getUser,
    addUser,
    editUser,
    storeUser,
    updateUser,
    transferUser,
    removeUser,
  };
}
